export default (status) => {
    const _maps = {
        waiting: 'Đang chờ',
        completed: 'Đã hoàn thành',
        free: 'Đang rảnh',
        disabled: 'Không được phép sử dụng',
    }

    return _maps[status] || status
}
